import React, { useState, useEffect, useRef } from 'react';


// ایمپورت ابزارهای کمکی و APIها
import { showError, showSuccess, showWarning } from '../../../utils/toastHelper';
import { getUserInfo, updateProfile } from '../api/ProfileAPIs';

// تصویر پیش‌فرض
import EmptyPic from '../../../assets/images/emptypic.png';
import Header from "../../../layouts/Header";

const EditProfile = () => {
    const [formData, setFormData] = useState({
        lastName: '',
        firstName: '',
        nationalCode: '',
        username: '',
        company_name: '',
        phone: '',
        email: '',
        oldPass: '',
        otpPassword: '',
    });

    const [picPreview, setPicPreview] = useState(EmptyPic);
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const fileInputRef = useRef(null);

    // دریافت اطلاعات اولیه کاربر
    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const response = await getUserInfo();
                const user = response.data.user;
                setFormData({
                    lastName: user.last_name || '',
                    firstName: user.first_name || '',
                    nationalCode: user.national_code || '',
                    phone: user.phone || '',
                    username: user.username || '',
                    company_name: user.company_name || '',
                    email: user.email || '',
                    oldPass: '',
                    otpPassword: '',
                });
                if (user.avatar) {
                    setPicPreview(user.avatar);
                }
            } catch (err) {
                showError('خطا در بارگذاری اطلاعات کاربر.');
            }
        };
        fetchUserData();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            const reader = new FileReader();
            reader.onloadend = () => {
                setPicPreview(reader.result);
            };
            reader.readAsDataURL(selectedFile);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formData.lastName.length < 3) {
            showWarning('نام خانوادگی باید حداقل ۳ کاراکتر باشد.');
            return;
        }
        if (formData.otpPassword && formData.otpPassword.length !== 4) {
            showWarning('رمز عبور جدید باید ۴ رقم باشد.');
            return;
        }

        setLoading(true);
        const apiFormData = new FormData();
        if (file) apiFormData.append('avatar', file);
        apiFormData.append('last_name', formData.lastName);
        apiFormData.append('first_name', formData.firstName);
        apiFormData.append('national_code', formData.nationalCode);
        apiFormData.append('phone', formData.phone);
        apiFormData.append('otp_password', formData.otpPassword);
        apiFormData.append('old_pass', formData.oldPass);
        apiFormData.append('email', formData.email);

        try {
            const response = await updateProfile(apiFormData);

            showSuccess(response.message || 'پروفایل با موفقیت به‌روزرسانی شد.');
        } catch (err) {

            showError(err.response.data.message || 'خطا در ثبت تغییرات.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="edit-profile-container container my-4">
            <Header hasBack={true} title='ویرایش پروفایل'/>
            <form onSubmit={handleSubmit} className="card p-3 p-md-4 shadow-sm">
                <div className="text-center mb-4">
                    <img
                        src={picPreview}
                        alt="Profile Preview"
                        className="profile-avatar"
                        onClick={() => fileInputRef.current.click()}
                    />
                    <input
                        type="file"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                        className="d-none"
                        accept="image/*"
                    />
                    <button
                        type="button"
                        className="btn btn-link btn-sm mt-2"
                        onClick={() => fileInputRef.current.click()}
                    >
                        تغییر تصویر پروفایل
                    </button>
                </div>

                <div className="row g-3">
                    {
                        formData.company_name?.length > 1 ?

                            <div className="col-md-6 form-floating">
                                <input type="text" className="form-control" id="company_name" name="company_name"
                                       value={formData.company_name} onChange={handleInputChange} placeholder="نام شرکت"/>
                                <label htmlFor="company_name">نام شرکت</label>
                            </div>
                            :
                            <div className="col-md-6 form-floating">
                                <input type="text" className="form-control" id="firstName" name="firstName"
                                       value={formData.firstName} onChange={handleInputChange} placeholder="نام"/>
                                <label htmlFor="firstName">نام</label>
                            </div>
                    }
                    <div className="col-md-6 form-floating">
                        <input type="text" className="form-control" id="lastName" name="lastName" value={formData.lastName}
                               onChange={handleInputChange} placeholder="نام خانوادگی" required/>
                        <label htmlFor="lastName">
                            نام خانوادگی
                            {
                                formData.company_name?.length > 1  && ' نماینده شرکت'
                            }
                        </label>
                    </div>
                    <div className="col-md-6 form-floating">
                        <input type="tel" className="form-control" id="username" name="username" value={formData.username} placeholder="شماره موبایل" readOnly />
                        <label htmlFor="username">شماره موبایل</label>
                    </div>
                    <div className="col-md-6 form-floating">
                        <input type="text" className="form-control" id="nationalCode" name="nationalCode" value={formData.nationalCode} onChange={handleInputChange} placeholder="کد ملی" />
                        <label htmlFor="nationalCode">کد ملی</label>
                    </div>
                    <div className="col-md-6 form-floating">
                        <input type="text" className="form-control" id="phone" name="phone" value={formData.phone} onChange={handleInputChange} placeholder="شماره ثابت" />
                        <label htmlFor="phone">شماره ثابت</label>
                    </div>
                    <div className="col-12 form-floating">
                        <input type="email" className="form-control" id="email" name="email" value={formData.email} onChange={handleInputChange} placeholder="آدرس ایمیل" />
                        <label htmlFor="email">آدرس ایمیل</label>
                    </div>
                </div>

                <div className="password-section mt-4 p-3 rounded">
                    <h6 className="mb-3">تغییر رمز عبور</h6>
                    <div className="form-floating mb-3">
                        <input type="password" name="oldPass" className="form-control" id="oldPass" value={formData.oldPass} onChange={handleInputChange} placeholder="رمز عبور کنونی" />
                        <label htmlFor="oldPass">رمز عبور کنونی</label>
                        <small className="form-text text-muted">اگر رمزی ندارید، خالی بگذارید.</small>
                    </div>
                    <div className="form-floating">
                        <input type="password" name="otpPassword" className="form-control" id="otpPassword" value={formData.otpPassword} onChange={handleInputChange} placeholder="رمز عبور جدید (۴ رقمی)" maxLength="4" />
                        <label htmlFor="otpPassword">رمز عبور جدید (۴ رقمی)</label>
                    </div>
                </div>

                <button type="submit" className="btn btn-primary w-100 mt-4 py-2" disabled={loading}>
                    {loading ? (
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    ) : (
                        'ثبت تغییرات'
                    )}
                </button>
            </form>
        </div>
    );
};

export default EditProfile;

